import BeelditSwitchInput from "@beeldit/core/components/BeelditSwitchInput";
import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import TreatmentSelector from "@main/treatments/components/TreatmentSelector";
import { Gear, Pencil, Plus, Trash } from "@phosphor-icons/react";
import { t } from "i18next";
import { min } from "lodash";

const config = {
  modelName: "customer-history",
  modelPluralName: "customer-histories",
  endpoint: "customer-histories",
  detailsFunctionPath: "/panel/1/1/customer-histories/",
  indexQueryParams: {
    
  },
  tableConfig: {
    index: null,
    actions: [
      {
        name: TableAction.CREATE,
        label: "create",
        showLabel: true,
        allowed: true,
        show: true,
        action: null,
        icon: <Plus size={20} />,
      },
    ],
    rowActions: [
      {
        name: RowAction.EDIT,
        label: "edit",
        icon: <Pencil size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("edit", element);
        },
      },
      {
        name: RowAction.DELETE,
        label: "delete",
        icon: <Trash size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("delete", element);
        },
      },
    ],
    rowConfiguration: {
      class: (element: any) => {
        return null;
      },
    },
    columns: [
      {
        name: "id",
        label: "#",
        key: "id",
        type: "number",
        show: true,
        allowOrder: true,
      },
      {
        name: "full_name",
        label: "full_name",
        key: "full_name",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "birthday",
        label: "birthday",
        key: "birthday",
        type: "date",
        show: true,
        allowOrder: true,
      },
      {
        name: "phone",
        label: "phone",
        key: "phone",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "email",
        label: "email",
        key: "email",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "status",
        label: "status",
        key: "status",
        type: "boolean",
        show: true,
        allowOrder: true,
      },
      {
        name: "treatments",
        label: "treatments",
        key: "treatments",
        attribute: "name",
        type: "array",
        show: true,
        allowOrder: true,
      },
    ],
    pagination: {
      enabled: true,
      back: true,
    },
  },
  filterConfig: {
    type: "object",
    properties: {
      search: {
        type: "string",
      },
      status: {
        type: ["boolean", "null"],
        title: t("customer_status"),
        default: null,
        oneOf: [
          {
            const: null,
            title: "Cualquier estado",
          },
          {
            const: 'false',
            title: "Inactivo",
          },
          {
            const: 1,
            title: "Activo",
          },          
        ],
      },
      treatment_id: {
        type: "number",
        title: t("treatment_id"),
      },
      origin: {
        type: "number",
        title: t("origin"),
        default: null,
        oneOf: [
          {
            const: null,
            title: "Todas las fuentes",
          },
          {
            const: 1,
            title: "Antiguo paciente",  
          },
          {
            const: 2,
            title: "Derivación profesional",
          },
          {
            const: 3,
            title: "Redes sociales",
          },
          {
            const: 4,
            title: "Web",
          },
          {
            const: 5,
            title: "Recomendación de un amigo/familiar",
          },
          {
            const: 6,
            title: "Otros",
          },
        ],
      }
    },
  },
  filterUIConfig: {
    uiScheme: {
      className: "filters-container",
      search: {
        "ui:options": {
          label: false, // Oculta el título del campo
          placeholder: "Buscar...",
        },
      },
      status: {
        "ui:widget": "select",
        "ui:options": {
          label: false,
        },
      },
      treatment_id: {
        "ui:widget": TreatmentSelector,
        "ui:options": {
          label: false,
        },
      },
      origin: {
        "ui:options": {
          label: false,
        },
      },
    },
    widgets: {},
  },
  formSchema: {
    type: "object",
    properties: {
      // clinical_history
      clinical_history: {
        type: ["string", "null"],
        title: t("clinical_history"),
        format: 'textarea',
      },
      // delivered_material
      delivered_material: {
        type: ["string", "null"],
        title: t("delivered_material"),
        format: 'textarea',
      },
    },
  },
  uiFormSchema: {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    colsSchema: [
      {
        cols: "col-12",
        elements: [
          [
            {
              name: "clinical_history",
              cols: "col-12",
            },
            {
              name: "delivered_material",
              cols: "col-12",
            },
          ],
        ],
      },
    ],
  },
};
export default config;
